import CostAnalysisReportTableRow from './CostAnalysisReportTableRow'
import {useContext, useEffect, useState} from 'react'
import {CostAnalysisReportContext} from '../../context'
import NoDataFound from '../../../../components/NoDataFound'
import {RenderBothArrow} from '../../../../utils/renderBothArrow'
import {toggleSortingOrder} from '../../../../utils/common'
import Loading from '../../../loading'

const CostAnalysisReportTable = () => {
  const {isLoading, costAnalysisReportList, onSortingChange, filters} =
    useContext(CostAnalysisReportContext)
  const [sortBy, setSortBy] = useState('')
  const [direction, setDirection] = useState<any>('')

  useEffect(() => {
    if (filters) {
      const array = filters?.['sort_by']?.split('/')
      setSortBy(array?.[0])
      if (array?.[1] === '1') {
        setDirection('asc')
      } else {
        setDirection('desc')
      }
    }
  }, [filters])

  return (
    <div className='card-body p-0'>
      <div className='sticky-table-wrapper'>
        <div className='table-responsive-wrapper'>
          <div className='table-responsive position-relative'>
            <div className='table-loader-wrapper'>
              <table className='table table-row-bordered table-row-gray-300 align-middle gs-0 gy-3 mb-5 pb-5'>
                <thead className='fw-semibold table-row-bordered sticky-table-header'>
                  <tr className='text-gray-700 text-uppercase'>
                    <th className='min-w-80 w-80px'></th>
                    <th
                      className='min-w-500px w-500px'
                      onClick={() =>
                        onSortingChange('parent_product_name', toggleSortingOrder(direction) || '')
                      }
                    >
                      <div className='d-flex align-items-center'>
                        <span className='me-2'>Product Name</span>
                        {direction === 'asc' && sortBy === 'parent_product_name' ? (
                          <i className='bi bi-caret-up-fill fs-8'></i>
                        ) : direction === 'desc' && sortBy === 'parent_product_name' ? (
                          <i className='bi bi-caret-down-fill fs-8'></i>
                        ) : (
                          <RenderBothArrow />
                        )}
                      </div>
                    </th>
                    <th
                      className='min-w-150px w-150px'
                      onClick={() =>
                        onSortingChange('parent_product_sku', toggleSortingOrder(direction) || '')
                      }
                    >
                      <div className='d-flex align-items-center'>
                        <span className='me-2'>SKU</span>
                        {direction === 'asc' && sortBy === 'parent_product_sku' ? (
                          <i className='bi bi-caret-up-fill fs-8'></i>
                        ) : direction === 'desc' && sortBy === 'parent_product_sku' ? (
                          <i className='bi bi-caret-down-fill fs-8'></i>
                        ) : (
                          <RenderBothArrow />
                        )}
                      </div>
                    </th>{' '}
                    <th
                      className='min-w-150px w-150px'
                      onClick={() =>
                        onSortingChange('cost_range', toggleSortingOrder(direction) || '')
                      }
                    >
                      <div className='d-flex align-items-center'>
                        <span className='me-2'>Current Cost</span>
                        {direction === 'asc' && sortBy === 'cost_range' ? (
                          <i className='bi bi-caret-up-fill fs-8'></i>
                        ) : direction === 'desc' && sortBy === 'cost_range' ? (
                          <i className='bi bi-caret-down-fill fs-8'></i>
                        ) : (
                          <RenderBothArrow />
                        )}
                      </div>
                    </th>
                    <th
                      className='min-w-175px w-175px'
                      onClick={() =>
                        onSortingChange('cost_margin', toggleSortingOrder(direction) || '')
                      }
                    >
                      <div className='d-flex align-items-center'>
                        <span className='me-2'>Cost Margin%</span>
                        {direction === 'asc' && sortBy === 'cost_margin' ? (
                          <i className='bi bi-caret-up-fill fs-8'></i>
                        ) : direction === 'desc' && sortBy === 'cost_margin' ? (
                          <i className='bi bi-caret-down-fill fs-8'></i>
                        ) : (
                          <RenderBothArrow />
                        )}
                      </div>
                    </th>{' '}
                    <th
                      className='min-w-150px w-150px'
                      onClick={() =>
                        onSortingChange('latest_po_cost_range', toggleSortingOrder(direction) || '')
                      }
                    >
                      <div className='d-flex align-items-center'>
                        <span className='me-2'>Last PO Cost</span>
                        {direction === 'asc' && sortBy === 'latest_po_cost_range' ? (
                          <i className='bi bi-caret-up-fill fs-8'></i>
                        ) : direction === 'desc' && sortBy === 'latest_po_cost_range' ? (
                          <i className='bi bi-caret-down-fill fs-8'></i>
                        ) : (
                          <RenderBothArrow />
                        )}
                      </div>
                    </th>
                    <th
                      className='min-w-225px w-225px'
                      onClick={() =>
                        onSortingChange('po_avg_cost_range', toggleSortingOrder(direction) || '')
                      }
                    >
                      <div className='d-flex align-items-center'>
                        <span className='me-2'>Avg. Cost of Last 3 POs</span>
                        {direction === 'asc' && sortBy === 'po_avg_cost_range' ? (
                          <i className='bi bi-caret-up-fill fs-8'></i>
                        ) : direction === 'desc' && sortBy === 'po_avg_cost_range' ? (
                          <i className='bi bi-caret-down-fill fs-8'></i>
                        ) : (
                          <RenderBothArrow />
                        )}
                      </div>
                    </th>
                    <th className='min-w-150px w-150px'>Last 3 PO Details</th>
                    </tr>
                </thead>
                <tbody>
                  {costAnalysisReportList?.length === 0 && !isLoading && (
                    <NoDataFound colspan={7} />
                  )}
                  {costAnalysisReportList?.map((row: any, index: any) => (
                    <CostAnalysisReportTableRow key={index} row={row} isChild={false} />
                  ))}
                </tbody>
              </table>
              {isLoading && <Loading />}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CostAnalysisReportTable
